import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { ROUTES } from '../../config/routes.config';
import { clearQrAdmitted, qrCaseViewPath, setQrLoginReturn } from '../../utils/qrSession';

/**
 * QR scan entry — always clears session and sends user to login.
 * After login they are redirected to the protected case view route.
 */
const CaseQREntryPage: React.FC = () => {
  const { caseId } = useParams<{ caseId: string }>();
  const { logout } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!caseId) {
      navigate(ROUTES.LOGIN, { replace: true });
      return;
    }
    const returnTo = qrCaseViewPath(caseId);
    clearQrAdmitted(caseId);
    setQrLoginReturn(returnTo);
    logout();
    navigate(ROUTES.LOGIN, {
      replace: true,
      state: { from: returnTo },
    });
  }, [caseId, logout, navigate]);

  return null;
};

export default CaseQREntryPage;
